export class Jobs {
    _id: string;
    id: string;
    name:string;
    alert_notes:string;
    skills: [{_id:string,id:string}];
    channel: {_id:string,id:string};
    source: [{_id:string,id:string}];
    technology: [{_id:string,id:string}];
    farming_by: [{_id:string,id:string}];
    hunting_by: [{_id:string,id:string}];
    priority: [{_id:string,id:string}];
    status: [{_id:string,id:string}];

    projectbudget: string;
    IP: string;
    description:string;
    references: [{_id:string,id:string,name:''}];
    notes:string;
    admin_notes:string;
    Communication: string;
    sprints: string;
    mom: string;
    dmsfrs: string;
    kpi: string;
    reports: string;
    workdairy: string;
    bitbucket: string;
    demo: string;
    qa: string;
    crequest: string;
    isalert: string;
    lead_id: { _id: '', id: '' };
    rate: string;
    engage_tags: [{_id:string,id:string}];
    feature: string;
    owner: [{_id:string,id:string}];
    auditor: [{_id:string,id:string}];
    publisher: [{_id:string,id:string}];
    marketer: [{_id:string,id:string}];
    codeName:string;
    config_notes:string;
    demo_notes :string;
    domain:string;
    developmentStage: [{_id:string,id:string}];
    marketStage:[{_id:string,id:string}];
    configState:[{_id:string,id:string}];
    modelCategory:[{_id:string,id:string}];
    modelVariant :[{_id:string,id:string}];
    modelSource:[{_id:string,id:string}];
    project_tag: [{_id:string,id:string}];
}

    
